import { getFulfilmentTypeByURL } from 'components/BookSlot/utils/get-fulfilment-type-by-url';

type FulfilmentType = Record<string, any> | undefined;
let previousFulfilmentType: FulfilmentType;

const shouldResetState = (
  prevFulfilmentType: FulfilmentType,
  currentFulfilmentType: FulfilmentType,
) => {
  if (!currentFulfilmentType) {
    return true;
  }

  if (!prevFulfilmentType && !!currentFulfilmentType) {
    return true;
  }

  if (prevFulfilmentType?.category !== currentFulfilmentType.category) {
    return true;
  }

  return false;
};

// TODO: [SSR][WARN] This is not SSR safe - Slots Team needs to address the use
// of side effects in this reducer.
const reducer = (state: WtrState, action: { payload: { location: { pathname: string } } }) => {
  const currentFulfilmentType = getFulfilmentTypeByURL(action.payload.location.pathname);
  let result;

  if (shouldResetState(previousFulfilmentType, currentFulfilmentType)) {
    // TODO: this codepath is not working as intended @slots
    // eslint-disable-next-line no-useless-assignment
    result = {
      ...state,
      branches: [],
    };
  }

  result = {
    ...state,
  };

  previousFulfilmentType = currentFulfilmentType;

  return result;
};

export default reducer;
